import _ from 'lodash'
import { createSelector } from 'reselect'
import { getLocale } from '../../imports'

export const getMotds = state => state.toasterReducer.motds.motds
export const getLatestMotdId = state => state.toasterReducer.motds.latestId
export const getLatestMotdTimeStamp = state => state.toasterReducer.motds.latestTimeStamp
export const getTempTimeStamp = state => state.toasterReducer.motds.tempTimeStamp

export const getLatestMotd = createSelector(
    [getMotds, getLatestMotdId],
    (motds, latestId) => motds[latestId],
)

const getShowableMotds = createSelector([getMotds, getLatestMotdId], (motds, latestId) => {
    // Only get motds that are visible
    const result = _.pickBy(
        motds,
        motd =>
            // Not dismissed
            motd.dismissed == null &&
            // Is visible
            motd.visible &&
            // Is unseen
            (!motd.seen ||
                // Or is the latest motd
                motd.id === latestId),
    )
    // console.log('getShowableMotds: ', motds, latestId, result)
    return result
})

// Get localized motds and throw out motds that don't exist in current locale
export const getLocalizedMotds = createSelector(
    [getShowableMotds, getLocale],
    (motds, locale) => {
        const res = _.reduce(
            motds,
            (result, motd) => {
                // If doesn't exist for locale, then skip it
                if (
                    motd.localized == null ||
                    motd.localized[locale] == null ||
                    motd.localized[locale].fetching !== undefined
                ) {
                    return result
                }

                result[motd.id] = motd
                result[motd.id].title = motd.localized[locale].title
                result[motd.id].content = motd.localized[locale].content

                return result
            },
            {},
        )
        // console.log('getLocalizedMotds: ', motds, locale, res)
        return res
    },
    // // Remove motds that don't exist in current locale
    // const result = _.pickBy(
    //     motds,
    //     motd =>
    //         motd.localized != null &&
    //         motd.localized[locale] != null &&
    //         motd.localized[locale].fetching === undefined,
    // )
)

export const getMotdsForStorage = createSelector(
    [getMotds, getLatestMotdId, getLatestMotdTimeStamp],
    (motds, latestId, latestTimeStamp) => {
        // Loop through all the motds we have...
        const storageMotds = _.reduce(
            motds,
            (result, toast) => {
                // We always add the latest motd, and all unseen messages
                // all other messages can be safely discarded
                if (toast.id === latestId || !toast.seen) {
                    // Now create the motd from the toast:
                    result[toast.id] = {
                        id: toast.id,
                        seen: toast.seen,
                        ...toast.motd,
                    }

                    result[toast.id].localized = _.omitBy(
                        toast.localized,
                        value => value.fetched != null,
                    )
                }

                return result
            },
            {},
        )
        return {
            motds: storageMotds,
            newestMotd: {
                id: latestId,
                timeStamp: latestTimeStamp,
            },
        }
    },
)



// WEBPACK FOOTER //
// ./src/features/Toaster/data/motds/selectors.js